// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_popup__y1Mx9 {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.9);
  height: 100%;
  width: 100%;
}
.styles_popup__y1Mx9 svg {
  position: absolute;
  top: 2rem;
  right: 2rem;
  fill: #fff;
  cursor: pointer;
  font-size: 20px;
  z-index: 100;
}
.styles_popup__y1Mx9 img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 5px solid #fff;
  border-radius: 5px;
  width: 750px;
  object-fit: cover;
}
@media (max-width: 768px) {
  .styles_popup__y1Mx9 img {
    width: 95%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Common/ImageBackdrop/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;AACJ;AAEI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AAAR;AAGI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AADR;AAGQ;EAVJ;IAWQ,UAAA;EAAV;AACF","sourcesContent":[".popup {\r\n    position: fixed;\r\n    z-index: 100;\r\n    top: 0;\r\n    left: 0;\r\n    background: rgba(0, 0, 0, 0.9);\r\n    height: 100%;\r\n    width: 100%;\r\n    // display: none;\r\n\r\n    svg {\r\n        position: absolute;\r\n        top: 2rem;\r\n        right: 2rem;\r\n        fill: #fff;\r\n        cursor: pointer;\r\n        font-size: 20px;\r\n        z-index: 100;\r\n    }\r\n\r\n    img {\r\n        position: absolute;\r\n        top: 50%;\r\n        left: 50%;\r\n        transform: translate(-50%, -50%);\r\n        border: 5px solid #fff;\r\n        border-radius: 5px;\r\n        width: 750px;\r\n        object-fit: cover;\r\n\r\n        @media (max-width: 768px) {\r\n            width: 95%;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `styles_popup__y1Mx9`
};
export default ___CSS_LOADER_EXPORT___;
